import {pluralize} from 'common/query-builder/cohorts-query-builder/util/index';

import {WindowUnit} from '../enums/expression-enums';
import {Serializable, SerializedBehaviorWindow, SerializedDatetime} from '../types/serialized-cohort-types';

export class BehaviorWindow implements Serializable {
  constructor(
    public unit: WindowUnit,
    public value: number,
  ) {}

  public toDateRangeString(): string {
    if (this.value < 0) {
      return `Next ${this.toRelativeRangeString()}`;
    }
    return `Last ${this.toRelativeRangeString()}`;
  }

  public toRelativeRangeString(): string {
    const absValue = Math.abs(this.value);
    return `${absValue > 1 ? `${absValue} ` : ``}${pluralize(this.unit, absValue)}`;
  }

  public getNumDays(): number | null {
    switch (this.unit) {
      case WindowUnit.Hour:
        if (this.value < 0) {
          return Math.min(-1, this.value / 24);
        }
        return Math.max(1, this.value / 24);
      case WindowUnit.Day:
        return this.value;
      case WindowUnit.Month:
        return this.value * 30;
      case WindowUnit.Week:
        return this.value * 7;
      default:
        return null;
    }
  }

  public equals(other: BehaviorWindow): boolean {
    return other && other.unit === this.unit && other.value === this.value;
  }

  public serialize(): SerializedBehaviorWindow {
    return {unit: this.unit, value: this.value};
  }

  public toSerializedRelativeDatetime(): SerializedDatetime {
    return {window: this.serialize()};
  }
}
